export default function MobileLayout({ header, content, mobileNav }) {
  return (
    <div className="flex md:hidden flex-col w-full h-full bg-slate-50">
      {header}
      <main className="flex-1 overflow-y-auto pb-[calc(88px+env(safe-area-inset-bottom))]">
        {content}
      </main>
      {mobileNav}
    </div>
  );
}

